export enum DictionaryItemStatus {
  CURRENT = 'C',
  OBSELETE = 'O',
}
